export default {
	AUTOMATION: 'companies/:company_id/automations'
}